export default __webpack_public_path__ + "static/media/shutterstock_652377421.e6f39f3d.png";